// extracted by mini-css-extract-plugin
module.exports = {"container":"Paginator_container__0rciJ","list":"Paginator_list___0k5l","listItem":"Paginator_listItem__hTUwB","active":"Paginator_active__riwIC"};